import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBan, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Panel from '~/components/ui/Panel';
import CompanyPartnershipLogo from './CompanyPartnershipLogo';

type PartnershipPanelProps = {
  hasPartnership: boolean;
  partnershipDetailsLink: string;
};

const PartnershipPanel: React.FC<PartnershipPanelProps> = ({
  hasPartnership,
  partnershipDetailsLink,
}) => {
  return hasPartnership ? (
    <Panel className="flex flex-col items-center justify-center gap-4 border-blue-300 bg-blue-25 py-4 md:flex-row md:justify-between md:py-6">
      <CompanyPartnershipLogo />
      <div className="flex w-full flex-col gap-4 md:pl-10 lg:flex-row">
        <span className="text-center text-sm md:mr-auto md:text-left md:text-lg lg:text-right">
          Advieskeuze heeft een samenwerking met deze organisatie.
        </span>
        <div className="flex items-center justify-center md:justify-start lg:justify-center">
          <a
            className="flex items-center justify-center gap-2 font-bold text-blue-700 no-underline hover:text-blue-800 md:text-lg"
            href={partnershipDetailsLink}
          >
            Meer informatie
            <FontAwesomeIcon icon={faChevronRight as IconProp} />
          </a>
        </div>
      </div>
    </Panel>
  ) : (
    <Panel className="md:align-center flex flex-col gap-4 border-tomato-300 bg-tomato-50 py-4 md:flex-row md:py-8">
      <FontAwesomeIcon
        icon={faBan as IconProp}
        className="text-2xl text-tomato-500"
      />
      <span className="mr-auto text-center text-sm md:text-left md:text-lg lg:text-right">
        <strong>Let op:</strong> Deze organisatie heeft nog geen samenwerking met Advieskeuze.
      </span>
    </Panel>
  );
};

export default PartnershipPanel;
